import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, money, imgSrc } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STATUS_STYLE = {
  paid: "bg-ink text-bone", shipped: "bg-sand text-ink", delivered: "bg-sand text-ink",
  pending: "border border-line text-stone", cancelled: "bg-signal text-white",
};

export const StatusPill = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-block px-3 py-1 font-mono text-[11px] uppercase tracking-widest ${STATUS_STYLE[status] || "border border-line"}`}>{status}</span>
);

export default function Account() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/orders/mine").then((r) => setOrders(Array.isArray(r.data) ? r.data : [])).catch(() => setOrders([]));
  }, [user]);

  if (user === null) return <main className="min-h-screen" />;
  if (user === false) return <Navigate to="/login" replace />;

  return (
    <main data-testid="account-page" className="mx-auto max-w-[1400px] px-5 pb-32 pt-28 md:px-10 md:pt-36">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="eyebrow">Account</p>
          <h1 data-testid="account-name" className="mt-4 font-display text-6xl font-light leading-none md:text-8xl">Hello, <em>{user.name?.split(" ")[0]}.</em></h1>
          <p className="mt-4 text-stone">{user.email}</p>
        </div>
        <button data-testid="logout-button" onClick={logout} className="w-fit rounded-full border border-ink px-6 py-3 text-sm transition-colors hover:bg-ink hover:text-bone">Sign out</button>
      </div>
      <h2 className="mt-20 font-display text-4xl font-light">Orders</h2>
      <div className="mt-6 border-t border-line" data-testid="orders-list">
        {orders === null ? <p className="py-8 text-stone">Loading…</p> : orders.length === 0 ? (
          <p data-testid="orders-empty" className="py-8 text-stone">No orders yet.</p>
        ) : orders.map((o) => (
          <div key={o.order_id} data-testid={`order-row-${o.order_id}`} className="grid gap-4 border-b border-line py-6 md:grid-cols-12 md:items-center">
            <span className="font-mono text-sm md:col-span-3">{o.order_id}</span>
            <span className="text-sm text-stone md:col-span-3">{new Date(o.created_at).toLocaleDateString("en-GB")}</span>
            <span className="flex -space-x-3 md:col-span-3">
              {(o.items || []).slice(0, 4).map((it) => <img key={`${it.product_id}-${it.size}`} src={imgSrc(it.image)} alt={it.name} className="h-12 w-10 border-2 border-bone object-cover" />)}
            </span>
            <span className="md:col-span-2"><StatusPill status={o.status} testid={`order-status-${o.order_id}`} /></span>
            <span className="font-mono text-sm md:col-span-1 md:text-right">{money(o.total)}</span>
          </div>
        ))}
      </div>
    </main>
  );
}
